export const getKilobytesFromString = (str: string): number => {
  if (typeof Blob !== 'undefined') {
    return new Blob([str || '']).size / 1000;
  }
  return Buffer.byteLength(str || '', 'utf-8') / 1000;
};
